import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  }

  // Redirect to login page
  router.navigate(['/login']);
  return false;
};

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  const expectedRoles = route.data['roles'] as string[];
  const user = authService.currentUser();

  if (user && expectedRoles.includes(user.role)) {
    return true;
  }

  // Handle unauthorized access
  if (user) {
    if (user.role === 'EMPLOYEE') {
      if (state.url !== '/elevators') {
        router.navigate(['/elevators']);
      } else {
        router.navigate(['/login']);
      }
    } else if (user.role === 'MANAGER' || user.role === 'SUPER_ADMIN') {
      if (state.url !== '/dashboard') {
        router.navigate(['/dashboard']);
      } else {
        router.navigate(['/login']);
      }
    } else {
      // Unknown or invalid role
      authService.logout();
    }
  } else {
    router.navigate(['/login']);
  }
  
  return false;
};
